module.exports = __webpack_public_path__ + "static/media/logo.651ddb55.png";